import { redirectWithPermissionCheck } from "@/router/index";
import { MAIN_NAVIGATION_ITEMS } from "@/router/constants";
import ApplicationTabs from "@/views/applications/ApplicationTabs";
import BookingDetails from "@/views/bookings/BookingDetails/BookingDetails";
import ApplicationDetails from "@/views/applications/ApplicationDetails";
import Applications from "@/views/applications/Applications.vue";

const { APPLICATIONS } = MAIN_NAVIGATION_ITEMS;

export const applicationsRouter = [
  {
    path: "/applications",
    name: APPLICATIONS,
    component: Applications,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, "applications");
    }
  },
  {
    path: "/applications/:id",
    name: "applicationTabs",
    redirect: "/applications/:id/role",
    component: ApplicationTabs,
    beforeEnter: (to, from, next) => {
      return redirectWithPermissionCheck(next, "applications");
    },
    children: [
      {
        path: "role",
        name: "applicationRole",
        component: BookingDetails,
        beforeEnter: (to, from, next) => {
          return redirectWithPermissionCheck(next, "applications");
        }
      },
      {
        path: "application",
        name: "applicationDetails",
        component: ApplicationDetails,
        beforeEnter: (to, from, next) => {
          return redirectWithPermissionCheck(next, "applications");
        }
      }
    ]
  }
];
